import { getAppOrigin } from './getAppOrigin';

export const isAppAbsoluteUrl = (url: string): boolean => url.startsWith(getAppOrigin());
